import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import TrainingEssaysList from './pages/TrainingEssaysList';
import TrainingEssayReview from './pages/TrainingEssayReview';
import AdminDashboard from './pages/AdminDashboard';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function Navigation() {
  const { user, logout } = useAuth();
  const location = useLocation();
  
  const isAdmin = () => {
    return user && (user.username === 'charles' || user.username === 'cillian' || user.role === 'admin');
  };

  if (location.pathname === '/login') {
    return null;
  }

  return (
    <nav style={{
      background: 'white',
      borderBottom: '1px solid #e5e7eb',
      padding: '0 20px'
    }}>
      <div className="container" style={{
        display: 'flex',
        gap: '20px',
        alignItems: 'center',
        height: '50px',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <Link
            to="/"
            style={{
              textDecoration: 'none',
              color: location.pathname === '/' ? '#3b82f6' : '#6b7280',
              fontWeight: location.pathname === '/' ? '600' : '400',
              padding: '10px 0'
            }}
          >
            Training Essays
          </Link>
          
          {isAdmin() && (
            <Link
              to="/admin"
              style={{
                textDecoration: 'none',
                color: location.pathname === '/admin' ? '#3b82f6' : '#6b7280',
                fontWeight: location.pathname === '/admin' ? '600' : '400',
                padding: '10px 0'
              }}
            >
              Admin Dashboard
            </Link>
          )}
        </div>
        {user && (
          <button
            onClick={logout}
            style={{
              background: '#ef4444',
              color: 'white',
              border: 'none',
              padding: '8px 12px',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Logout
          </button>
        )}
      </div>
    </nav>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <header className="teacher-header">
            <div className="container">
              <h1>Pulc.AI Teacher Review</h1>
              <p>Review and edit feedback for training essays</p>
            </div>
          </header>

          <Navigation />

          <main className="container">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<TrainingEssaysList />} />
              <Route path="/essay/:trainingId" element={<TrainingEssayReview />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 